import { render } from "./Toasts.vue?vue&type=template&id=faa12be0&scoped=true"
import script from "./Toasts.vue?vue&type=script&lang=js"
export * from "./Toasts.vue?vue&type=script&lang=js"

import "./Toasts.vue?vue&type=style&index=0&id=faa12be0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-faa12be0"]])

export default __exports__